<script setup lang="ts">
  import { computed, markRaw } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDeviceStore } from '@/stores'
  import DefaultItinerary from './index.vue'
  import GcomeApItinerary from '../itinerary-gcome-ap/index.vue'

  const defaultItinerary = markRaw(DefaultItinerary)
  const gcomeApItinerary = markRaw(GcomeApItinerary)
  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)

  const activePage = computed(() =>
    currentDevice.value?.manifest.driver === 'GCOME_AP' ? gcomeApItinerary : defaultItinerary,
  )
</script>

<template>
  <component :is="activePage" />
</template>
